import { API } from "@/js/accounts/utils/api.js";

export default () => ({
    loginInit() {
        const params = new URLSearchParams(window.location.search);
        if (window.location.pathname !== "/account/login/") {
            this.next = window.location.pathname + window.location.search;
        } else {
            this.next = params.get("next") || "/account/my-account/";
        }

        this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        API.POST.sessionCreate()
            .then(response => {
                if (!response.ok) {
                    this.loginError = 'Session creation failed. Please try again.';
                    throw new Error('Session creation failed');
                }
                return response.json();
            })
            .then(() => {
                this.loginError = '';
                this.email = '';
                this.password = '';
                this.showPassword = false;
            })
            .catch(error => {
                this.loginError = 'An error occurred while logging in. Please try again.';
                console.error('Login error:', error);
            });
    },

    csrfToken: false,
    loginError: '',
    email: '',
    password: '',
    errors: {},

    validateForm() {
        const form = document.getElementById('login-form');
        if (!form.checkValidity()) {
            form.reportValidity();
            return false;
        }
        return true;
    },

    async submitForm() {
        this.loginError = '';
        if (!this.email || !this.password) {
            this.loginError = 'Please enter email and password';
            return;
        }
        if (!this.validateForm()) {
            return;
        }

        const payload = {
            email: this.email,
            password: this.password,
            next: this.next,
        };

        try {
            const response = await API.POST.login(this.csrfToken, payload);
            if (!response.ok) {
                this.loginError = 'Login failed. Please check your credentials and try again.';
                return;
            }
            const data = await response.json();
            if (data.IsLoggedIn) {
                const affiliationType = data?.affiliation_type;
                const membershipData = data?.school_membership_data;
                if (affiliationType && membershipData) {
                    console.log(membershipData);
                    const expirationDate = new Date(membershipData.ExpirationDateTime);
                    const today = new Date();
                    if (expirationDate > today) {
                        console.log("Membership is valid, redirecting to next page.");
                        window.location.href = this.next || "/account/dashboard/";
                    }
                }
                console.log("User is logged in to Tess CRM but no affiliation or membership data found.");
                window.location.href = "/account/register/?link-school=true&next=" + encodeURIComponent(this.next);

            } else {
                this.loginError = 'Login failed. Please check your credentials and try again.';
            }
        } catch (error) {
            this.loginError = 'An error occurred while logging in. Please try again.';
            console.error('Login error:', error);
        }
    }
});
